export const SKILL_EVENTS = {
  SKILL_DOWNLOADED: "Skill Downloaded",
  SKILLS_PAGE_OPENED: "Skills Page Opened",
  SKILL_ENABLED: "Skill Enabled",
  SKILL_DISABLED: "Skill Disabled",
  SKILL_FILE_VIEWED: "Skill File Viewed",
  SKILL_SHARED: "Skill Shared",
  SKILL_UNSHARED: "Skill Unshared",
  SKILL_RUN_CLICKED: "Skill Run Clicked",
} as const
